<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Animal Health
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <report-comment field_name="heading_animal_health" :model="model.COMMENTS" :heading="true"></report-comment>

      <subsection
        title="Other Health Issues"
        :step-name="stepName"
        subsection="other_health_issues"
        v-for="farm in model.FARMS"
        :key="`other_health_issues_${farm.id}`"
      >
        <h4 class="text-left">{{ farm.farm_label }}</h4>
        <report-comment
          :field_name="`farm_${farm.id}-heading_other_health_issues`"
          :model="model.COMMENTS"
          :heading="true"
        ></report-comment>
        <dl class="dl-horizontal">
          <dt>Down Cow</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_downcow`] || '-' }}</dd>

          <dt>Bloat</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_bloat`] || '-' }}</dd>

          <dt>Pink Eye</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_pinkeye`] || '-' }}</dd>

          <dt>Acidosis</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_acidosis`] || '-' }}</dd>

          <dt>Scouring</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_scouring`] || '-' }}</dd>

          <dt>Abortions</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_abortions`] || '-' }}</dd>

          <dt>Sudden Death</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_suddendeath`] || '-' }}</dd>

          <dt>Salmonella</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_salmonella`] || '-' }}</dd>

          <dt>Polio</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_polio`] || '-' }}</dd>

          <dt>Calvings</dt>
          <dd>{{ model.COMMENTS.current[`farm_${farm.id}-other_issues_calvings`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection title="Flowcharts" :step-name="stepName" subsection="flowcharts">
        <div v-for="farm in model.FARMS" :key="'flowcharts_' + farm.id">
          <h4 class="text-left">{{ farm.farm_label }}</h4>
          <report-comment
            :field_name="`farm_${farm.id}-flowcharts`"
            :model="model.COMMENTS"
            :heading="true"
          ></report-comment>
          <dl class="dl-horizontal">
            <dt v-if="model[`farm_${farm.id}-flowchart_mastitis`]">Mastitis</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_down_cows`]">Down Cow</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_rfms`]">RFMs</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_calving`]">Calvings</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_post_calving`]">Post-calving</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_calf_rearing`]">Calf Rearing</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_animal_health_plan`]">Animal Health Plan</dt>
            <dd></dd>

            <dt v-if="model[`farm_${farm.id}-flowchart_young_stock_health_plan`]">Young Stock Health Plan</dt>
            <dd></dd>
            <dt v-if="model[`farm_${farm.id}-flowchart_rumination`]">Rumination sick cow</dt>
            <dd></dd>
            <dt v-if="model[`farm_${farm.id}-flowchart_fluid_therapy`]">Dairy fluid therapy</dt>
            <dd></dd>
          </dl>
        </div>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'AnimalHealth',
  mixins: [mixin],
}
</script>
